import api from '@/api'

const namespaced = true

const state = {
  userNotifications: []
}

const getters = {
  userNotifications: state => state.userNotifications
}

const mutations = {
  SET_NOTIFICATIONS: (state, payload) => {
    state.userNotifications = payload
  }
}

const actions = {
  async fetchNotifications({ commit }, payload) {
    try {
      const data = await api.getUserNotifications(payload)
      if (data?.data?.error) {
        commit('SET_NOTIFICATIONS', [])
        return
      }

      commit('SET_NOTIFICATIONS', data?.data)
    } catch (err) {
      commit('SET_NOTIFICATIONS', [])
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
